<template>
  <div>
    <el-dialog
      :title="getTitle()"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      width="80%"
      top="5vh"
    >
      <div class="preview-content" v-loading="loading">
        <!-- 企业预览 -->
        <div v-if="role === 'company'" class="company-preview">
          <!-- Banner轮播 -->
          <div class="banner-section" v-if="formattedData.bannar && formattedData.bannar.length > 0">
            <el-carousel height="300px" indicator-position="outside">
              <el-carousel-item v-for="(item, index) in formattedData.bannar" :key="index">
                <img :src="getImagePath(item)" :alt="'Banner ' + (index + 1)" class="banner-image" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else class="no-data">
            <p>暂无Banner图片</p>
          </div>

          <!-- 基本信息 -->
          <div class="info-section">
            <h3>基本信息</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <label>所属协会：</label>
                  <span>{{ formattedData.name || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>地址：</label>
                  <span>{{ formattedData.address || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>联系电话：</label>
                  <span>{{ formattedData.phone || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>邮箱：</label>
                  <span>{{ formattedData.email || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>排序：</label>
                  <span>{{ formattedData.sort || '50' }}</span>
                </div>
              </el-col>
              <el-col :span="8" v-if="formattedData.camera_pass">
                <div class="info-item">
                  <label>在线工厂密码：</label>
                  <span>******</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 企业图片 -->
          <div class="image-section">
            <h3>企业图片</h3>
            <div class="image-grid" v-if="formattedData.image && formattedData.image.length > 0">
              <div v-for="(img, index) in formattedData.image" :key="index" class="image-item">
                <img :src="getImagePath(img)" :alt="'企业图片 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无企业图片</p>
            </div>
          </div>

          <!-- 企业视频 -->
          <div class="video-section">
            <h3>企业视频</h3>
            <div class="video-grid" v-if="formattedData.video && formattedData.video.length > 0">
              <div v-for="(video, index) in formattedData.video" :key="index" class="video-item">
                <video :src="getImagePath(video)" controls class="video-player"></video>
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无企业视频</p>
            </div>
          </div>

          <!-- 视频封面 -->
          <div class="cover-section">
            <h3>视频封面</h3>
            <div class="image-grid" v-if="formattedData.cover && formattedData.cover.length > 0">
              <div v-for="(cover, index) in formattedData.cover" :key="index" class="image-item">
                <img :src="getImagePath(cover)" :alt="'视频封面 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无视频封面</p>
            </div>
          </div>

          <!-- 企业资质 -->
          <div class="qualifications-section">
            <h3>企业资质</h3>
            <div class="image-grid" v-if="formattedData.qualifications && formattedData.qualifications.length > 0">
              <div v-for="(qual, index) in formattedData.qualifications" :key="index" class="image-item">
                <img :src="getImagePath(qual)" :alt="'资质 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无企业资质</p>
            </div>
          </div>

          <!-- 企业荣誉 -->
          <div class="honors-section">
            <h3>企业荣誉</h3>
            <div class="honors-list" v-if="formattedData.honora && formattedData.honora.length > 0">
              <div v-for="(honor, index) in formattedData.honora" :key="index" class="honor-item">
                <div class="honor-content">
                  <p class="honor-text">{{ honor.text || '荣誉内容' }}</p>
                  <div class="honor-images" v-if="honor.images && honor.images.length > 0">
                    <img v-for="(img, imgIndex) in honor.images" :key="imgIndex" 
                         :src="getImagePath(img)" :alt="'荣誉图片 ' + (imgIndex + 1)" />
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无企业荣誉</p>
            </div>
          </div>

          <!-- 企业介绍 -->
          <div class="intro-section">
            <h3>企业介绍</h3>
            <div class="intro-content" v-if="formattedData.intro" v-html="formattedData.intro"></div>
            <div v-else class="no-data">
              <p>暂无企业介绍</p>
            </div>
          </div>

          <!-- 公众号二维码 -->
          <div class="qrcode-section">
            <h3>公众号二维码</h3>
            <div class="qrcode-grid" v-if="formattedData.qrcode && formattedData.qrcode.length > 0">
              <div v-for="(qrcode, index) in formattedData.qrcode" :key="index" class="qrcode-item">
                <img :src="getImagePath(qrcode)" alt="公众号二维码" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无公众号二维码</p>
            </div>
          </div>
        </div>

        <!-- 政府预览 -->
        <div v-if="role === 'government'" class="government-preview">
          <!-- Banner轮播 -->
          <div class="banner-section" v-if="formattedData.bannar && formattedData.bannar.length > 0">
            <el-carousel height="300px" indicator-position="outside">
              <el-carousel-item v-for="(item, index) in formattedData.bannar" :key="index">
                <img :src="getImagePath(item)" :alt="'Banner ' + (index + 1)" class="banner-image" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else class="no-data">
            <p>暂无Banner图片</p>
          </div>

          <!-- 基本信息 -->
          <div class="info-section">
            <h3>基本信息</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <label>地址：</label>
                  <span>{{ formattedData.address || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>联系电话：</label>
                  <span>{{ formattedData.phone || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>邮箱：</label>
                  <span>{{ formattedData.email || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>排序：</label>
                  <span>{{ formattedData.sort || '50' }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 政府图片 -->
          <div class="image-section">
            <h3>政府图片</h3>
            <div class="image-grid" v-if="formattedData.image && formattedData.image.length > 0">
              <div v-for="(img, index) in formattedData.image" :key="index" class="image-item">
                <img :src="getImagePath(img)" :alt="'政府图片 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无政府图片</p>
            </div>
          </div>

          <!-- 政府视频 -->
          <div class="video-section">
            <h3>政府视频</h3>
            <div class="video-grid" v-if="formattedData.video && formattedData.video.length > 0">
              <div v-for="(video, index) in formattedData.video" :key="index" class="video-item">
                <video :src="getImagePath(video)" controls class="video-player"></video>
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无政府视频</p>
            </div>
          </div>

          <!-- 政府荣誉 -->
          <div class="honors-section">
            <h3>政府荣誉</h3>
            <div class="text-honors-list" v-if="formattedData.honors && formattedData.honors.length > 0">
              <div v-for="(honor, index) in formattedData.honors" :key="index" class="text-honor-item">
                <p>{{ honor.text || '荣誉内容' }}</p>
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无政府荣誉</p>
            </div>
          </div>

          <!-- 政府介绍 -->
          <div class="intro-section">
            <h3>政府介绍</h3>
            <div class="intro-content" v-if="formattedData.intro" v-html="formattedData.intro"></div>
            <div v-else class="no-data">
              <p>暂无政府介绍</p>
            </div>
          </div>

          <!-- 公众号二维码 -->
          <div class="qrcode-section">
            <h3>公众号二维码</h3>
            <div class="qrcode-grid" v-if="formattedData.qrcode && formattedData.qrcode.length > 0">
              <div v-for="(qrcode, index) in formattedData.qrcode" :key="index" class="qrcode-item">
                <img :src="getImagePath(qrcode)" alt="公众号二维码" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无公众号二维码</p>
            </div>
          </div>
        </div>

        <!-- 商会预览 -->
        <div v-if="role === 'shanghui'" class="shanghui-preview">
          <!-- Banner轮播 -->
          <div class="banner-section" v-if="formattedData.bannar && formattedData.bannar.length > 0">
            <el-carousel height="300px" indicator-position="outside">
              <el-carousel-item v-for="(item, index) in formattedData.bannar" :key="index">
                <img :src="getImagePath(item)" :alt="'Banner ' + (index + 1)" class="banner-image" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else class="no-data">
            <p>暂无Banner图片</p>
          </div>

          <!-- 基本信息 -->
          <div class="info-section">
            <h3>基本信息</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="info-item">
                  <label>所属协会：</label>
                  <span>{{ formattedData.name || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>地址：</label>
                  <span>{{ formattedData.address || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>联系电话：</label>
                  <span>{{ formattedData.phone || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>邮箱：</label>
                  <span>{{ formattedData.email || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="info-item">
                  <label>排序：</label>
                  <span>{{ formattedData.sort || '50' }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 商会图片 -->
          <div class="image-section">
            <h3>商会图片</h3>
            <div class="image-grid" v-if="formattedData.image && formattedData.image.length > 0">
              <div v-for="(img, index) in formattedData.image" :key="index" class="image-item">
                <img :src="getImagePath(img)" :alt="'商会图片 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无商会图片</p>
            </div>
          </div>

          <!-- 商会视频 -->
          <div class="video-section">
            <h3>商会视频</h3>
            <div class="video-grid" v-if="formattedData.video && formattedData.video.length > 0">
              <div v-for="(video, index) in formattedData.video" :key="index" class="video-item">
                <video :src="getImagePath(video)" controls class="video-player"></video>
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无商会视频</p>
            </div>
          </div>

          <!-- 企业资质 -->
          <div class="qualifications-section">
            <h3>企业资质</h3>
            <div class="image-grid" v-if="formattedData.qualifications && formattedData.qualifications.length > 0">
              <div v-for="(qual, index) in formattedData.qualifications" :key="index" class="image-item">
                <img :src="getImagePath(qual)" :alt="'资质 ' + (index + 1)" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无企业资质</p>
            </div>
          </div>

          <!-- 商会介绍 -->
          <div class="intro-section">
            <h3>商会介绍</h3>
            <div class="intro-content" v-if="formattedData.intro" v-html="formattedData.intro"></div>
            <div v-else class="no-data">
              <p>暂无商会介绍</p>
            </div>
          </div>

          <!-- 公众号二维码 -->
          <div class="qrcode-section">
            <h3>公众号二维码</h3>
            <div class="qrcode-grid" v-if="formattedData.qrcode && formattedData.qrcode.length > 0">
              <div v-for="(qrcode, index) in formattedData.qrcode" :key="index" class="qrcode-item">
                <img :src="getImagePath(qrcode)" alt="公众号二维码" />
              </div>
            </div>
            <div v-else class="no-data">
              <p>暂无公众号二维码</p>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!formattedData || Object.keys(formattedData).length === 0" class="empty-state">
          <el-empty description="暂无预览数据"></el-empty>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Supply_detailApi from '@/api/supply_detail.js';

export default {
  props: ["open_preview", "preview_data", "role"],
  data() {
    return {
      dialogVisible: false,
      formattedData: {},
      loading: false
    };
  },
  watch: {
    open_preview: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val && this.preview_data && this.preview_data.supply_detail_id) {
          this.getDetailData();
        }
      }
    }
  },
  methods: {
    getTitle() {
      const titles = {
        'company': '企业详情预览',
        'government': '政府详情预览',
        'shanghui': '商会详情预览'
      };
      return titles[this.role] || '详情预览';
    },

    dialogFormVisible() {
      this.$emit("close");
    },

    // 从接口获取完整详情数据
    getDetailData() {
      this.loading = true;
      Supply_detailApi.detail({ supply_detail_id: this.preview_data.supply_detail_id }, true)
        .then(res => {
          this.loading = false;
          this.formatData(res.data);
        })
        .catch(error => {
          this.loading = false;
          console.error('获取详情失败:', error);
          this.$message.error('获取详情失败');
        });
    },

    getImagePath(item) {
      // 处理图片路径，兼容不同数据格式
      if (!item) return '';
      if (typeof item === 'string') return item;
      return item.file_path || item.url || '';
    },

    formatData(data) {
      if (!data) {
        this.formattedData = this.getDefaultData();
        return;
      }

      // 深拷贝数据
      const formatted = JSON.parse(JSON.stringify(data));
      
      // 处理 qualifications 字段（可能是JSON字符串）
      if (formatted.qualifications && typeof formatted.qualifications === 'string') {
        try {
          formatted.qualifications = JSON.parse(formatted.qualifications);
        } catch (e) {
          console.error('解析qualifications失败:', e);
          formatted.qualifications = [];
        }
      }

      // 处理 qrcode 字段（可能是JSON字符串）
      if (formatted.qrcode && typeof formatted.qrcode === 'string') {
        try {
          formatted.qrcode = JSON.parse(formatted.qrcode);
        } catch (e) {
          console.error('解析qrcode失败:', e);
          formatted.qrcode = [];
        }
      }

      // 确保所有数组字段都是数组
      const arrayFields = [
        'bannar', 'image', 'video', 'cover', 'bg', 
        'qrcode', 'qualifications', 'honora', 'honors',
        'core_members'
      ];

      arrayFields.forEach(field => {
        if (!Array.isArray(formatted[field])) {
          formatted[field] = [];
        }
      });

      // 处理荣誉数据格式
      if (formatted.honors && Array.isArray(formatted.honors)) {
        formatted.honors = formatted.honors.map(honor => {
          if (typeof honor === 'string') {
            return { text: honor };
          }
          return honor;
        });
      }

      if (formatted.honora && Array.isArray(formatted.honora)) {
        formatted.honora = formatted.honora.map(honor => {
          if (typeof honor === 'string') {
            return { text: honor, images: [] };
          }
          return honor;
        });
      }

      this.formattedData = { ...this.getDefaultData(), ...formatted };
    },

    getDefaultData() {
      return {
        name: '',
        address: '',
        phone: '',
        email: '',
        sort: 50,
        intro: '',
        bannar: [],
        image: [],
        video: [],
        cover: [],
        bg: [],
        qrcode: [],
        qualifications: [],
        honora: [],
        honors: [],
        core_members: [],
        camera_pass: ''
      };
    }
  }
};
</script>

<style scoped>
.preview-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 10px;
}

.banner-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.info-section {
  margin: 20px 0;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.info-section h3 {
  margin-bottom: 15px;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 8px;
}

.info-item {
  margin: 8px 0;
  line-height: 1.6;
}

.info-item label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.image-section,
.video-section,
.qualifications-section,
.honors-section,
.qrcode-section,
.intro-section,
.cover-section {
  margin: 20px 0;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.image-section h3,
.video-section h3,
.qualifications-section h3,
.honors-section h3,
.qrcode-section h3,
.intro-section h3,
.cover-section h3 {
  margin-bottom: 15px;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 8px;
}

.image-grid,
.qrcode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.image-item img,
.qrcode-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: transform 0.3s ease;
}

.image-item img:hover,
.qrcode-item img:hover {
  transform: scale(1.05);
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.video-player {
  width: 100%;
  height: 200px;
  border-radius: 4px;
  background: #000;
}

.honors-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.honor-item {
  padding: 12px;
  background: white;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.honor-text {
  margin-bottom: 10px;
  color: #303133;
  font-weight: bold;
}

.honor-images {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.honor-images img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.text-honors-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.text-honor-item {
  padding: 10px;
  background: white;
  border-radius: 4px;
  border-left: 4px solid #67c23a;
}

.intro-content {
  background: white;
  padding: 15px;
  border-radius: 4px;
  min-height: 100px;
  line-height: 1.6;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-style: italic;
  background: white;
  border-radius: 4px;
  margin-top: 10px;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .image-grid,
  .qrcode-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
  
  .video-grid {
    grid-template-columns: 1fr;
  }
  
  .banner-image {
    height: 200px;
  }
  
  .info-section .el-col {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/detail/part/preview.vue